import React from 'react';
import styled from 'styled-components';
import {FlexColumn} from '../../StyledUtils';
import {Icon} from '../../StyledUtils';
import XSVG from '../../images/icons/x.svg';

export const FloatingAddWOTContainer = styled(FlexColumn)`
  position: fixed;
  z-index: 9999;
  top: 58px;
  right: 24px;
  padding: 46px 16px 16px 16px;
  align-items: center;
  min-width: 180px;
  border-radius: 2px;
  border: solid 1px #eaeaea;
  background-color: #ffffff;
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.15);
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  color: #252525;
  transition: opacity 0.3s ease-in-out;
  opacity: ${({isHidden}) => isHidden ? 0 : 1};
  pointer-events: ${({isHidden}) => isHidden ? 'none' : 'all'};
`;

export const Circle = styled.div`
  position: absolute;
  top: -32px;
  width: 64px;
  height: 64px;
  border: solid 1px #eaeaea;
  background-color: #ffffff;
  border-radius: 50%;
`;

export const CloseIcon = styled(Icon).attrs({
    children: <XSVG />
})`
  position: absolute;
  top: 11px;
  right: 3px;
  fill: #252525;
  cursor: pointer;
`;

export const CacheOnly = styled.div`
  position: absolute;
  opacity: 0;
  pointer-events: none;
`;
